import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { EventconfigStoreService } from '../../shared/eventconfig-store.service';
import { Eventsetup } from '../../shared/eventsetup';
import { EventsetupStoreService } from '../../shared/eventsetup-store.service';
import { LogService } from '../../shared/log.service';
import { PlayerStoreService } from '../../shared/player-store.service';
import { Question } from '../../shared/question';
import { QuestionStoreService } from '../../shared/question-store.service';

@Component({
    selector: 'lse-vod-question-list',
    templateUrl: './vod-question-list.component.html',
    styleUrls: ['./vod-question-list.component.css'],
    animations: [
        trigger('inOutAnimation', [
            transition(':enter', [
                style({ height: 0, opacity: 0 }),
                animate('1.5s ease-in', style({ height: 0, opacity: 1 }))
            ]),
            transition(':leave', [
                style({ height: 0, opacity: 1 }),
                animate('1s ease-in', style({ height: 0, opacity: 0 }))
            ])
        ]),
        trigger('slideInOut', [
            state('in', style({
                overflow: 'hidden',
                height: '*'
            })),
            state('out', style({
                overflow: 'hidden',
                height: '0px'
            })),
            transition('in => out', animate('250ms ease-in-out')),
            transition('out => in', animate('250ms ease-in-out'))
        ])
    ],
    standalone: false
})
export class VodQuestionListComponent implements OnInit {
  @Input() pageSize: number;
  @Input() language: string;
  @Output() playAtEvent = new EventEmitter();
  @Output() questionCount = new EventEmitter<number>();

  questions: Question[];
  page = 1;
  vodCount: number;
  vodQDisplay: number[];
  vodFrom: number;
  vodTo: number;
  count = 0;
  pageSizes = [5, 10, 15];
  holdMyTime: any;
  screenwidth = document.body.offsetWidth;
  eSetup: Eventsetup;
  eLangGlob: any;
  showQuestionVod = 'in';
  lastPageEnd;
  manualPageChange: boolean;
  //Question(true) Chapter(false)
  questionOrChapter: Boolean = true;

  constructor(
    private qs: QuestionStoreService,
    private logger: LogService,
    private ep: EventsetupStoreService,
    protected es: EventconfigStoreService,
    private vs: PlayerStoreService
  ) {
  }

  ngOnInit(): void {
    this.retrieveVodMsg();
    this.eLangGlob = this.es.getLangGlobals();
    this.eSetup = this.ep.getStoredSetup();
    this.vodQDisplay = this.getFromTo();
    this.vodFrom = this.vodQDisplay[0];
    this.vodTo = this.vodQDisplay[1];
    setInterval(() => {
      this.pageCheck();
    }, 500);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenwidth = window.innerWidth;
  }


  retrieveVodMsg() {
      this.qs.getAllPaginationNew().subscribe((data) => {
        /*console.log(data);*/
        this.questions = data['message'];
        this.count = data['message'].length;
        this.questionCount.emit(data['message'].length);
      });
  }

handlePageChange(page): void {
  this.lastPageEnd =
    this.questions.length > 1
      ? this.questions[this.questions.length - 1].videoTime
      : Infinity;

  this.logger.log(
    'Page: ' + this.count + ' Calc: ' + (this.page + 1) * this.pageSize
  );

  if (page === 'plus' && this.count > this.page * this.pageSize) {
    this.page++;
    this.manualPageChange = true;
  }
  if (page === 'minus' && this.page > 1) {
    this.page--;
    this.manualPageChange = true;
  }
  if (page === 'plusAuto' && this.count > this.page * this.pageSize) {
    this.page++;
  }
  if (page === 'minusAuto' && this.page > 1) {
    this.page--;
  }

  this.vodQDisplay = this.getFromTo();
  this.vodFrom = this.vodQDisplay[0];
  this.vodTo = this.vodQDisplay[1];
}

  handlePageSizeChange(event): void {
    this.pageSize = event.target.value;
    this.page = 1;
  }

  handleEvent(value) {
    this.holdMyTime = value;
    this.playAtEvent.emit(value);
    this.logger.log(value);
  }

  getFromTo() {
    // Sprachabhängig!
    // return ('Fragen ' + (((this.page - 1) * this.pageSize) + 1) + ' bis ' + ((this.page) * this.pageSize));
    return [(this.page - 1) * this.pageSize + 1, this.page * this.pageSize];
  }

  toggleQuestionsVod() {
    this.showQuestionVod = this.showQuestionVod === 'out' ? 'in' : 'out';
  }

pageCheck() {
  if (!this.manualPageChange) {
    let numStart: number;
    let numEnd: number;

    numStart = this.questions[(this.page - 1) * this.pageSize].videoTime[this.language];

    if (this.questions[this.page * this.pageSize - 1] === undefined) {
      numEnd = Infinity;
    } else {
      numEnd = this.questions[this.page * this.pageSize - 1].videoTime[this.language];
    }

    if (numEnd < Math.round(this.vs.getCurrentPlayTime())) {
      this.sycQuestions();
    }
    if (numStart > Math.round(this.vs.getCurrentPlayTime())) {
      this.sycQuestions();
    }
  }
}

  changeManualPageChangeFalse() {
    this.manualPageChange = false;
  }

sycQuestions() {
  for (let i = 0; i < this.count; i++) {
    let numStart = this.questions[i].videoTime[this.language];
    let numEnd = i < this.count - 1 ? this.questions[i + 1].videoTime[this.language] : Infinity;

    if (
      numStart <= Math.round(this.vs.currentPlayTime) &&
      numEnd >= Math.round(this.vs.currentPlayTime)
    ) {
      this.page = Math.ceil((i + 1) / this.pageSize);
      this.vodQDisplay = this.getFromTo();
      this.vodFrom = this.vodQDisplay[0];
      this.vodTo = this.vodQDisplay[1];
    }
  }
}

  protected readonly Infinity = Infinity;
}
